import React, { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CrossBrandTrafficProps } from '@srcDS/components/organisms/crossBrandTraffic/hooks/useCrossBrandTraffic';

import styles from './CrossBrandTraffic.module.scss';

const normalizeUrl = (url: string): string => url.replace(/\/+$/, '');

export const CrossBrandTraffic = memo(({ brands, crossBrandTrafficColors }: CrossBrandTrafficProps) => {
  const [isMounted, setIsMounted] = useState(false);

  const isEmpty = !brands || brands.length === 0 || brands.every(item =>
    !item.uniqueId && !item.url && !item.name
  );

  if (isEmpty) {
    return null;
  }

  const projectId = useSelector((state) => {
    return state?.app?.context?.project?.projectId || state?.app?.context?.project?.name?.toLowerCase();
  });

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const getBrandClassName = (uniqueId: string) => {
    if (!uniqueId) return '';

    const cleaned = uniqueId
      .replace(/[^a-zA-Z0-9]/g, '')
      .toLowerCase();

    const capitalized = cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
    const result = capitalized.replace(/nz$/i, 'Nz');

    return `brandItem${result}`;
  };

  const getActiveBrand = (brandUrl: string, currentOrigin: string) => {
    if (!brandUrl || !currentOrigin) return false;

    const normalize = (url) => {
      return normalizeUrl(url)
        .replace(/^https?:\/\//, '')
        .replace(/^(production-|local\.|www\.)/, '')
    };

    return normalize(brandUrl) === normalize(currentOrigin);
  };

  if (!isMounted) {
    return (
      <ul className={styles.crossBrandTraffic} style={{ height: '40px' }}>
        {brands.map((brand) => (
          <li key={brand.uniqueId} className={styles.brandItemPlaceholder} />
        ))}
      </ul>
    );
  }

  const currentOrigin = normalizeUrl(window.location.origin);
  const currentBrand = brands.find((brand) => normalizeUrl(brand.url) === currentOrigin);

  const { bgColor, selectedColor } = crossBrandTrafficColors?.[0] || {};

  return (
    <ul className={styles.crossBrandTraffic} style={{ backgroundColor: bgColor }}>
      {brands.map((brand) => {
        const isActive = getActiveBrand(brand.url, currentOrigin);
        return (
          <li
            key={brand.uniqueId}
            className={`${styles.brandItem} ${isActive ? styles.active : ''} ${styles[getBrandClassName(brand.uniqueId)]}`}
            style={{ backgroundColor: isActive ? selectedColor : bgColor }}
          >
            <a
              href={`${normalizeUrl(brand.url)}?brand_origin=${currentBrand?.uniqueId ?? projectId}`}
              className={styles.brandLink}
            >
              <img src={brand.media} alt={brand.name} className={styles.brandLogo} />
            </a>
          </li>
        );
      })}
    </ul>
  );
});

export default CrossBrandTraffic;